export default __webpack_public_path__ + "static/media/kor.d1b13d2b.svg";